import React, { Component } from 'react';
import Avatar from 'material-ui/Avatar';
import TextField from 'material-ui/TextField';
import 'moment-timezone/builds/moment-timezone-with-data-2012-2022';
import moment from 'moment-timezone';
import config from '../../config/config'
import { FormattedMessage } from 'react-intl';
import { displayRole,checkMobile,APIFunc,isSentryBreadcrumbs } from '../../lib/lib'
import ReactTinyLink from "react-tiny-link";

const scrollPositionOffset = 350
const createMarkup = (text) => {
  return {__html: (/\r|\n/.test(text)) ? text.replace(/\r|\n/g, '<br />') : text};
};

const DivStyle = (res) => {
  let text = res.text
  let position = res.res
  let url = res.url
  return <div className={
    `${(position === 'right') ? 'mr3' : 'ml3'}
    pa3 br2 message-color
    ${(position === 'right') ? 'arrow-right' : 'arrow-left'}
      `}
    style={{ wordWrap: 'break-word', fontSize: 14 }}>
    {url ? <div dangerouslySetInnerHTML={createMarkup(text)}/> : text}
    </div>
}
class OGPChat extends React.Component {
  state = {
    title: "",
    status: false
  }
  componentWillReceiveProps(newProps) {
    try{
      const {res} = newProps;
      let text = res
      let pattern = /(http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&amp;:/~\+#]*[\w\-\@?^=%&amp;/~\+#])?/gm;
      let urls = text.match(pattern)
      let th = this;
      urls && APIFunc(urls['0']).then(data => {
        const doc = new DOMParser().parseFromString(data, "text/html");
        const title = doc.querySelectorAll('title')[0];
        const metDescription = doc.querySelector("meta[name='description']");
        const description = metDescription ? metDescription.getAttribute("content") : null;
        let titleText = title ? title.innerHTML : null
          th.setState({
            title: titleText
          })
        })
      }
     catch(error){
      const message = "chat componentWillReceiveProps() failed"
      isSentryBreadcrumbs(error,message)
     }   
  }

  componentDidUpdate() {
    let logoImage = document.getElementsByClassName('urlLogo')
    logoImage  = logoImage[logoImage.length - 1]
    if(logoImage) {
      logoImage.children[0].onload = () => {
        logoImage.children[0].style.display = "block"; 
      }
    }
  }

  render() {
      const {res, position} = this.props;
      let text = res
      let pos = position
      let pattern = /(http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&amp;:/~\+#]*[\w\-\@?^=%&amp;/~\+#])?/gm;
      let urls = text.match(pattern)
      let logoURL= urls && urls['0'].split("/")['2']
      let logo = "https://logo.clearbit.com/"+logoURL
      //var count = urls && urls['0'].split('http').filter(function(n) { return n != '' }).length;
      var replacePattern1 = /((https?|ftp):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gim;
      let replacedText = text.replace(replacePattern1, '<a href="$1" target="_blank">$1</a>');
      var replacePattern2 = /(^|[^\/])(www\.[\S]+(\b|$))/gim;
      replacedText= replacedText.replace(replacePattern2, '$1<a href="$2" target="_blank">$2</a>');
      if(pattern.test(text)) {
        return <div>
          <DivStyle res={position} text={replacedText} url={urls[0]}/>      
            <div className="mt2 mr3 ml3 message-color" >
            {this.state.title &&  <ReactTinyLink cardSize="large" showGraphic={true} maxLine={2} minLine={1} url={urls[0]} />}
            {logo && this.state.title && <div style={{position:"relative"}} className="urlLogo">
                 <img src={logo} id="logoImage" width="30" height="30px" style={{display:"none"}}/>
              </div>
            }  
            </div>  
          </div> 
      } else {
      return <DivStyle res={pos} text={text}/> 
      }
    }
   
}
const ChatBox = ({ isWebinar, position, text, time, imageURI }) => {
  return <div
    className='flex mt3'
    style={{ flexDirection: (position === 'right') ? 'row-reverse' : 'row' }}>
    <Avatar style={{ backgroundColor: 'rgb(188, 188, 188)'}} src={imageURI} className='w-10' />
    <div className="chatMessage">
        <OGPChat res={text} position={position}/>
      { isWebinar && <div
        style={{ color: '#6B7C93', fontSize: 12 }}
        className={`flex justify-end mt2 ${(position === 'right') ? 'mr3' : ''}`}>
        {time}
      </div> }
    </div>
  </div>
};

export default class Chat extends Component {
  state = {
    chats: [],
    chatText: '',
    title: ''
  }

  componentDidMount () {
    this.scrollToBottom();
  }


  componentDidUpdate () {
    const objDiv = document.getElementById('chat-list');
    const scrollPosition = objDiv.scrollHeight - (objDiv.offsetHeight + objDiv.scrollTop)
    if (scrollPosition < scrollPositionOffset) {
      this.scrollToBottom();
    }
  }


  componentWillReceiveProps(props){
    const objDiv = document.getElementById('chat-list');
    const scrollPosition = objDiv.scrollHeight - (objDiv.offsetHeight + objDiv.scrollTop)
    if (scrollPosition < scrollPositionOffset) {
      this.scrollToBottom();
    }
  }


  trimText (str) {
    str = str.replace(/^\s+/, '');
    for (var i = str.length - 1; i >= 0; i--) {
      if (/\S/.test(str.charAt(i))) {
        str = str.substring(0, i + 1);
        break;
      }
    }
    return str;
  }

  sendChat = (chatText) => {
    try{
      const { chats } = this.state;
      if (chatText.trim().length !== 0) {
        let obj = {};
        chatText = this.trimText(chatText);
        obj.text = chatText
        obj.time = moment.tz('Asia/Tokyo').unix()
        this.setState({ chats, chatText: '' });
        this.props.handleChat(obj.text, obj.time, false)
        this.scrollToBottom();
      } 
    }
    catch(error){
      const message = "chat sendChat() failed"
      isSentryBreadcrumbs(error,message)
    }
  }

  handleSubmit = (e) => {
    try{
      e.preventDefault();
      const { chatText } = this.state;
      this.sendChat(chatText);
    }
    catch(error){
      const message = "chat handleSubmit() failed"
      isSentryBreadcrumbs(error,message)
    }
  }

  handleKeyPress = (e) => {
    try{
      if (e.keyCode === 13 && (e.altKey || e.shiftKey)) {
        let { chatText } = this.state;
        chatText = chatText ;
        return this.setState({ chatText });
      }
      if (e.which === 13) {
        e.preventDefault();
        const { chatText } = this.state;
        this.sendChat(chatText);
      }
    }
    catch(error){
      const message = "chat handleKeyPress() failed"
      isSentryBreadcrumbs(error,message)
    }  
  }

  scrollToBottom = () => {
    try{
      const objDiv = document.getElementById('chat-list');
      if (objDiv) {
        objDiv.scrollTop = objDiv.scrollHeight;
      }
    }
    catch(error){
      const message = "chat scrollToBottom() failed"
      isSentryBreadcrumbs(error,message)
    }
  }

  handleChange = (e) => {
    try{
      this.setState({ chatText: e.target.value });
    }
    catch(error){
      const message = "chat handleChange() failed"
      isSentryBreadcrumbs(error,message)
    }
  }

  render () {
   
    // if(imgDiv) {
    //   imgDiv.children[0].onload = () => {
    //     imgDiv.children[0].style.height = checkMobile() ? "100%" : "150px"; 
    //   }
    // }
    return (
      <div className='h-100'>
        <div
          id='chat-list'
          style={{ height: this.props.isWebinar ? '68vh' : checkMobile() ? '66vh' : '76vh' }}
          className='pa3 overflow-auto'>
          { this.props.chat && this.props.chat.map((val, index) => (
            <ChatBox
              isWebinar={this.props.isWebinar}
              key={index}
              style={{background:'#fff'}}
              imageURI={this.props.isWebinar ? ((val.direct) ? ("https://" + config.API_HOST + "/api/v1/image/" + val.name) : ("https://" + config.API_HOST + "/api/v1/image/" + val.user_id )) : val.base64Data ? val.blob : ""}
              position={this.props.user_name === val.name ? 'right' : 'left'}
              time={`${val.name} (${displayRole(this.props.location, val.role)}) at ${moment(val.time,'X').local().format('lll')}`}
              text={val.text} />
          ))}
        </div>
        <form
          onSubmit={this.handleSubmit}
          className='absolute bottom-0 w-100 flex'
          style={{ height: '15vh', padding: '0 8px', borderTop: '1px solid #1C79D2',background:"#fff" }}>
          <div className='w-100' >
            <TextField
              underlineShow={false}
              fullWidth
              value={this.state.chatText}
              onKeyDown={(e) => { this.handleKeyPress(e) }}
              onChange={(e) => { this.handleChange(e) }}
              hintText={<FormattedMessage id='main.typechat' />}
              textareaStyle={{ height: '13vh', margin: '8px 0'}}
              hintStyle={{top: 5}}
              multiLine={true}
              rows={5}
              />
          </div>
        </form>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/BreakOutTabs/Chat.js